module.exports = __webpack_public_path__ + "img/mt-clickbait-decor.-mobile.46d67402.svg";